(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["codex-grillz-cut-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('codex-grillz-cut-selector')) {
    class CodexGrillzCutSelector extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-info');
        if (!this.scope) return;
        this.sync = this.syncProperties.bind(this);
        this.addEventListener('change', this.sync);
        this.scope.addEventListener('submit', this.sync, true);
        this.scope.addEventListener('click', this.syncBeforePurchase, true);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.scope, { childList: true, subtree: true });
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('change', this.sync);
        this.scope?.removeEventListener('submit', this.sync, true);
        this.scope?.removeEventListener('click', this.syncBeforePurchase, true);
      }

      syncBeforePurchase(event) {
        if (!event.target.closest('button[type="submit"], .shopify-payment-button')) return;
        this.querySelectorAll('codex-grillz-cut-selector').forEach(selector => selector.syncProperties());
      }

      syncProperties() {
        const selected = this.querySelector('input[type="radio"]:checked');
        if (!selected || !this.scope) return;
        this.scope.querySelectorAll('input[data-grillz-cut-property]').forEach(input => {
          if (input.dataset.grillzCutProperty === this.dataset.productId && input.closest('product-info') === this.scope) {
            input.value = selected.value;
          }
        });
      }
    }
    customElements.define('codex-grillz-cut-selector', CodexGrillzCutSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
